import * as moment from "moment";
import "moment-timezone";
import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import Timer from "slotworks/utils/timer";
import settingsModel, { Jurisdiction } from "slotworks/model/settings/settings-model";

export default class ClockComponent {
    private clockText: FlexiText;

    private timer: number;

    private static NL_Timezone = "Europe/Amsterdam";

    constructor() {
        this.clockText = Layers.Header.getFlexiText("clock");

        if (this.clockText != null) {

            const millisecondsLeft = 60000 - moment().seconds() * 1000;

            this.updateClock(millisecondsLeft);
        }
    }

    public destroy() {
        Timer.clearTimeout(this.timer);
    }

    private updateClock(milliseconds: number = 60000) {
        if(settingsModel.isJurisdiction(Jurisdiction.NL)) {
            this.clockText.setText((moment as any).tz(ClockComponent.NL_Timezone).format("HH:mm"));
        } else {
            this.clockText.setText(moment().format("HH:mm"));
        }

        this.timer = Timer.setTimeout(() => {
            this.updateClock();
        }, milliseconds);
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/header/clock-component.ts